<template>
  <div class="water-on-paper-chart">
    <default-chart
      chart-id="water-on-paper-chart"
      x-data-manager="dateTime"
      :chart-data="chartData"
      :loading="loading"
      :remove-outlier.sync="removeChartOutlier"
      :enable-multi-axis.sync="enableChartMultiAxis"
      @toggle-outlier="getChartData(true)"
      @toggle-multi-axis="getChartData(true)"
    />
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import DefaultChart from '@/components/charts/DefaultChart';
import Service from '@/domain/services/installation/engineering/waterOnPaper/waterOnPaperService';
import defaultChartMixin from '@/domain/mixins/defaultChartMixin';

export default {
  name: 'WaterOnPaperChartTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { DefaultChart },
  mixins: [defaultChartMixin],
  data: () => ({
    chartData: [],
    loading: false,
  }),
  created() {
    this.init();
    this.refreshData(true);
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;
      this.getChartData(showLoading);
    },
    getChartData(showLoading = false) {
      this.loading = showLoading;
      Service.getChart(this.$route.params.assetModuleId, this.chartFilters).then((response) => {
        this.chartData = response;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
